import type { CreateAgencyInput, UpdateAgencyInput } from '@idc-forms/schemas'
import { axiosPrivate } from '@/shared/api/axios'
import { buildListQueryString } from '@/shared/api/build-list-query-string'
import { API } from '@/shared/constants/api'
import type { AgenciesAdminParams, AgencyAdminRow, PaginatedAgencies } from '../models/agency-admin'

export async function getAgenciesAdmin(params: AgenciesAdminParams): Promise<PaginatedAgencies> {
  const qs = buildListQueryString(params)
  const { data } = await axiosPrivate.get<PaginatedAgencies>(
    `${API.agencies.root}${qs ? `?${qs}` : ''}`
  )
  return data
}

/** Los payloads son los MISMOS schemas Zod que valida el backend. */
export async function createAgency(payload: CreateAgencyInput): Promise<AgencyAdminRow> {
  const { data } = await axiosPrivate.post<AgencyAdminRow>(API.agencies.root, payload)
  return data
}

export async function updateAgency(
  id: string,
  payload: UpdateAgencyInput
): Promise<AgencyAdminRow> {
  const { data } = await axiosPrivate.patch<AgencyAdminRow>(API.agencies.byId(id), payload)
  return data
}

export async function deleteAgency(id: string) {
  const { data } = await axiosPrivate.delete(API.agencies.byId(id))
  return data
}
